<template>
	<div id="app" class="login-bg">
		<component :is="layout">
			<router-view/>
		</component>
	</div>
</template>

<style lang="less">
	body > .alert {
		z-index: 3000;
	}
	section {
		min-height: 600px;
	}
	.label {
		border: 0;
		margin-right: 4px;
		margin-bottom: 4px;
	}
</style>

<script>
export default {
	computed: {
		layout() {
			return this.$route.meta.layout;
		}
	}
};
</script>
